import { createTheme } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

export const CustomTheme = createTheme(themeBase, {
  palette: {
    primary: {
      main: "#5850EB",
      dark: "#1A1583",
      light: "#DAD5FF",
    },
    secondary: {
      main: "#F2704F",
    },
    backgroundRight: {
      main: "#5850EB",
      dark: "#1A1583",
      light: "#DAD5FF",
      tab: "#EDEBFD",
    },
    phoneInput: {
      main: "#EDEBFD",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#1A1583",
      tabText: "#FFFFFF",
      tabBackground: "#1A1583",
      menuIcon: "#69D6DE",
    },
    barProgress: {
      main: "#5850EB",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#DAD5FF",
      barColor: "#1A1583",
      iconColor: "#69D6DE",
      markLabelColor: "#5D5BDB",
    },
    buttonSelected: {
      backgroundColor: "#DAD5FF",
      backgroundColorActive: "#5D5BDB",
      textColor: "#333F48",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#E9AEF9",
    },
    screenBackground: {
      backgroundColor: "#EDEBFD",
      textColor: "#1A1583",
      subTextColor: "#594DEB",
      iconColor: "#69D6DE",

      backgroundColorBofu: "#EDEBFD",
      textColorBofu: "#1A1583",
      subTextColorBofu: "#594DEB",
      iconColorBofu: "#69D6DE",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#DAD5FF",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#DAD5FF",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#DAD5FF",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#5850EB",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#5850EB",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#1A1583",
              color: "#DAD5FF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#5850EB",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#528CD6",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#5850EB",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },

        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#5850EB",
              opacity: 0.4,
              color: "#FFF",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#F2704F",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#F2704F",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F2704F",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#1A1583",
            backgroundColor: "#FFF",
            border: "2px solid #1A1583",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#DAD5FF",
            color: "#FFFFFF",
            backgroundColor: "#1A1583",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#1A1583",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#1A1583",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#5850EB",
            backgroundColor: "#DAD5FF",
            "&.Mui-disabled": {
              backgroundColor: "#DAD5FF",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#DAD5FF",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#5850EB",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#5850EB",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#1A1583",
              color: "#DAD5FF",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#DAD5FF", // Borde azul cuando no está enfocado
              borderRadius: "10px",
            },
            "&:hover fieldset": {
              borderColor: "#DAD5FF", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#DAD5FF", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#DAD5FF", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#DAD5FF",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#DAD5FF",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#1A1583",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "nowports",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: "/aviso_de_privacidad",
  terminos_condiciones: "/terminos_y_condiciones",
  interest_rate: 18,
  metadata: {
    title: "NowPorts",
    description:
      "NowPorts es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "now_ports/portal/logos/favicon.ico",
    keywords: "fintech México, créditos digitales, NowPorts, plataforma financiera, préstamos online",
    ogImage: "https://develop.d1yqxqednb1e91.amplifyapp.com/opengraph-image.jpg?c044d823f8594106",
  },
  navbar: {
    logo: "now_ports/portal/logos/logo_navbar.png",
    logo_width: 142,
    logo_height: 32,
  },
  lateral: {
    logo_light: "now_ports/portal/logos/logo_light_bg.png",
    bg_light: "#8C87F7",
    text_light: "#FFFFFF",
    logo_dark: "now_ports/portal/logos/logo_dark_bg.png",
    bg_dark: CustomTheme.palette.primary.dark,
    text_dark: "#FFFFFF",
    image_list: [
      "now_ports/portal/lateral/imagen_1.webp",
      "now_ports/portal/lateral/imagen_2.webp",
      "now_ports/portal/lateral/imagen_3.webp",
      "now_ports/portal/lateral/imagen_4.webp",
      "now_ports/portal/lateral/imagen_5.webp",
      "now_ports/portal/lateral/imagen_6.webp",
      "now_ports/portal/lateral/imagen_7.webp",
      "now_ports/portal/lateral/imagen_8.webp",
      "now_ports/portal/lateral/imagen_9.webp",
      "now_ports/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Da el siguiente paso en tu crecimiento",
      "Lleva tu empresa más lejos con Nowports",
      "El respaldo financiero que tu operación necesita",
      "Más capital, más entregas, más resultados",
      "Financia el movimiento que tu empresa necesita",
      "El siguiente destino de tu negocio empieza aquí",
      "Capital inteligente para empresas en movimiento",
      "Llega más rápido, crece más fuerte",
      "Crédito ágil, operaciones sin freno",
      "Impulsa tu empresa, acelera tus resultados",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario y/o representante legal",
        sub_titulo:
          "En caso de tener más de un accionista en igualdad de acciones,\ningresar al que además funja como Representante Legal",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario y/o representante legal",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario y/o representante legal",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  cotizador: {
    current_currency: "USD",
    tasa_text: "+ SOFR",
    term_type: "días",
  },
  companyNames: ["Avenida Vessel SAPI de CV SOFOM", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario y/o Representante Legal de la empresa mencionada en esta solicitud.",
  firma: {
    provider: "mifiel",
    //"legalario",
    legalario_config: {
      custom_url_sdk:
        import.meta.env.VITE_ENV === "PROD"
          ? "https://sdk.legalario.com/3.0/sdk-dist.js"
          : "https://sdk.legalario.com/3.0/sdk-dev.js",
      organization_id: import.meta.env.VITE_ENV === "PROD" ? "651dec2d1f1e0d09a2532e64" : "651f490f1cd1fd5c2199c942",
      api_key:
        import.meta.env.VITE_ENV === "PROD"
          ? "9bcdd0595e6faf4c15caabce560ff7e8f0a9b56fbcf7e6374d372046fa3bcc40"
          : "9bcdd0595e6faf4c15caabce560ff7e8f0a9b56fbcf7e6374d372046fa3bcc40",
    },
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: true,
    },
    habilitar_comsion_apertura: true,
  },
  scripts: {
    tag_id_hotjar: "6487599",
    tag_id_google: "",
    tag_id_linkedin: "",
    tag_id_meta_pixel: "",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_sFjcqtCtk",
      userPoolClientId: "2pousl3im2gqghpte6eve21ti0",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_d5F4QKmWv",
      userPoolClientId: "6nbgtk3boancvo16cleok986nm",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
